const isOwnPropertyKey = <ObjectType extends object>(
  value: ObjectType,
  key: PropertyKey,
): key is keyof ObjectType => Object.prototype.hasOwnProperty.call(value, key);

/**
 * Read a dynamically named own property without widening an exact object into
 * an open dictionary. Missing and inherited keys return `undefined`.
 */
export const getOwnProperty = <ObjectType extends object>(
  value: ObjectType,
  key: PropertyKey,
): ObjectType[keyof ObjectType] | undefined =>
  isOwnPropertyKey(value, key) ? value[key] : undefined;
